module.exports = __webpack_public_path__ + "static/media/ktm.27923908.mp4";